import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import ".././../styles/diet/diet.css";
import MealsStructure from "../../components/diet/meal/MealsStructure";
import { fetchAllDietPlanData } from "../../redux/reducers/apiSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectToken } from "../../components/auth/auth.selector";
import DietPlanFilters from "../../components/diet/diet-plans/DietPlanFilters";
import DietPlanTable from "../../components/diet/diet-plans/DietPlanTable";
import HelmetWrapper from "../../HelmetWrapper";

const DietPlan = () => {
  const dispatch = useDispatch();
  const token = useSelector(selectToken);

  const { dietPlansData } = useSelector((state) => state.api);

  const iniDietPlanData = {
    isPage: 0,
    pagination: [],
    allPlans: [],
  };
  const [dietPlans, setDietPlans] = useState(iniDietPlanData);

  const iniDdFilters = {
    category: "",
    createdBy: "",
    status: "",
    searchString: "",
  };
  const [ddFilters, setDdFilters] = useState(iniDdFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const [sendableQPs, setSendableQPs] = useState("");

  const onClickSearch = () => {
    setSearchFilterApplied(true);
    const searchQP = ddFilters.searchString
      ? `&search=${ddFilters.searchString}`
      : "";

    setSendableQPs((prevQP) => prevQP + searchQP);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };

  useEffect(() => {
    dispatch(
      fetchAllDietPlanData({
        pageNo: dietPlans.isPage + 1,
        limit: 10,
        queryParameters: sendableQPs,
        token: token,
      })
    );
  }, [dietPlans.isPage, sendableQPs]);

  useEffect(() => {
    if (ddFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setSendableQPs((prevQP) => prevQP.replace(/&search=[^&]*/, ""));
    }
  }, [ddFilters.searchString]);

  useEffect(() => {
    if (dietPlansData?.status && dietPlansData?.data?.length > 0) {
      const { data, pagination } = dietPlansData || {};

      setDietPlans((prevs) => ({
        ...prevs,
        allPlans: data,
        pagination: pagination,
      }));
    } else {
      setDietPlans((prevs) => ({
        ...prevs,
        allPlans: [],
        pagination: [],
      }));
    }
  }, [dietPlansData]);

  return (
    <HelmetWrapper title="WTF: Diet Plan">
      <>
        <Container
          className="bg-cloud-k dietMealsParentContainer px-50px"
          fluid
        >
          <Row>
            <Col>
              <MealsStructure text={"Diet Plans"} />
            </Col>
          </Row>
          <Row>
            <Col>
              <DietPlanFilters
                token={token}
                filters={ddFilters}
                setFilters={setDdFilters}
                searchFilterApplied={searchFilterApplied}
                onClickSearch={onClickSearch}
                callFunction={() =>
                  dispatch(
                    fetchAllDietPlanData({
                      pageNo: dietPlans.isPage + 1,
                      limit: 10,
                      queryParameters: sendableQPs,
                      token: token,
                    })
                  )
                }
                handleKeyPress={handleKeyPress}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <DietPlanTable
                dietPlans={dietPlans}
                setDietPlans={setDietPlans}
                callFunction={() =>
                  dispatch(
                    fetchAllDietPlanData({
                      pageNo: dietPlans.isPage + 1,
                      limit: 10,
                      queryParameters: sendableQPs,
                      token: token,
                    })
                  )
                }
              />
            </Col>
          </Row>
        </Container>
      </>
    </HelmetWrapper>
  );
};

export default DietPlan;
